import Component from './component';
import Swiper from 'swiper/dist/js/swiper.js';
import createComponentFactory from '../createComponent';

class RecommendSlider extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this.slides = null;

    this.pager = null;
    this.prev = null;
    this.next = null;

    this._sliderContext = null;
  }

  _bindEvents() {

  }

  _unbindEvents() {

  }

  _initSlider() {
    this.slides = this.element.querySelector('.js-homeRecommend__slides');
    this.pager = this.element.querySelector('.js-homeRecommend__pager');
    this.prev = this.element.querySelector('.js-homeRecommend__prev');
    this.next = this.element.querySelector('.js-homeRecommend__next');

    this._sliderContext = new Swiper(this.slides, {
      speed: 600,
      slidesPerView: 'auto',
      freeMode: true,
      loop: true,
      initialSlide: 4,
      navigation: {
        nextEl: this.next,
        prevEl: this.prev
      },
      pagination: {
        el: this.pager,
        bulletElement: 'span',
        type: 'bullets',
        clickable: true,
        renderBullet:  (index, className) => {
          return `<span class="${className} home-recommend__page"></span>`;
        }
      }
    });
  }

  _watchDomInsertedByRecommendEngine() {

    setTimeout(() => {
      if(this.element.querySelector('.js-homeRecommend__slides')) {
        this._initSlider();
      } else {
        this._watchDomInsertedByRecommendEngine();
      }
    }, 1000);
  }

  didRegisterComponent() {

    this._watchDomInsertedByRecommendEngine();
    this._bindEvents();
  }

  didUnregisterComponent() {


    this._unbindEvents();
  }
}

export default createComponentFactory(RecommendSlider);



// WEBPACK FOOTER //
// ./src/js/app/component/recommendSlider.js